import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PartnerService } from '../../../core/partner.service';
import { AppSettingSection } from '../../../user-notifications/legacy-notification-preference/legacy-notification-preference.service';
import { VConfigService } from '../../../vconfig/vconfig.service';
import { SELECT_OPTION } from '../user-bulk-actions.component';
import { UserBulkActionsService } from '../user-bulk-actions.service';

@Component({
  selector: 'app-bulk-notifications-change',
  templateUrl: './bulk-notifications-change.component.html',
  styleUrls: ['./bulk-notifications-change.component.scss'],
  standalone: false,
})
export class BulkNotificationsChangeComponent implements OnInit, OnDestroy {
  notifications: any[];
  dropdownOptions = [
    {
      id: SELECT_OPTION.DONT_UPDATE,
      name: "Don't Update",
      key: 'USERS.BULK_UPDATE_SETTINGS.DONT_UPDATE',
    },
    {
      id: SELECT_OPTION.GIVE_ACCESS,
      name: 'Turn On',
      key: 'USERS.BULK_UPDATE_SETTINGS.TURN_ON',
    },
    {
      id: SELECT_OPTION.REMOVE_ACCESS,
      name: 'Turn Off',
      key: 'USERS.BULK_UPDATE_SETTINGS.TURN_OFF',
    },
  ];
  partnerId = this.partnerService.partnerId;

  private componentDestroyed$$: Subject<any> = new Subject();

  constructor(
    private userBulkActionsService: UserBulkActionsService,
    private partnerService: PartnerService,
    private vConfigService: VConfigService,
  ) {}

  ngOnInit(): void {
    this.notifications = this.generateNotificationObject();
    this.vConfigService
      .getConfigurations(this.partnerService.partnerId, ['vbc_product_name'])
      .pipe(takeUntil(this.componentDestroyed$$))
      .subscribe((vbcDetails) => {
        this.notifications[1].name = vbcDetails.vbc_product_name;
      });
  }

  ngOnDestroy(): void {
    this.componentDestroyed$$.next('bye');
  }

  getClass(settingId: string, sectionIndex: number, optionIndex: number): string {
    const notification = this.notifications.find((notif) => notif.settingId === settingId);
    const notifValue = notification.sections[sectionIndex].options[optionIndex].value;
    if (notifValue === undefined) {
      return '';
    }
    if (notifValue) {
      return 'give-access';
    }
    return 'remove-access';
  }

  selectChange(section: AppSettingSection): void {
    this.userBulkActionsService.setNotificationUpdate({
      setting: section.sectionId,
      section: section.sectionType,
      title: section.title,
      valueFlag: section.value,
    });
  }

  private generateNotificationObject(): any {
    return [
      {
        settingId: 'globalSettings',
        name: 'Global Settings',
        iconType: 'public',
        sections: [
          {
            name: 'Global Email Settings',
            options: [
              {
                name: 'Instant Email (When Available)',
                section: 'instantEmailFlag',
                setting: 'instantEmailFlag',
                value: undefined,
              },
              {
                name: 'Daily Digest',
                section: 'activityDigestEmailFlag',
                setting: 'activityDigestEmailFlag',
                value: undefined,
              },
            ],
          },
        ],
      },
      {
        settingId: 'businessAppSettings',
        name: 'Business App',
        iconUrl: 'https://vbc-prod.appspot.com/static/images/file-upload.png',
        sections: [
          {
            name: 'Executive Report Email',
            options: [
              {
                name: 'Monthly Executive Report',
                section: 'executiveReportFlag',
                setting: 'VBC:Monthly Executive Report',
                value: undefined,
              },
              {
                name: 'Weekly Executive Report',
                section: 'executiveReportFlag',
                setting: 'VBC:Weekly Executive Report',
                value: undefined,
              },
            ],
          },
        ],
      },
    ];
  }
}
